export const RAS_TURNOS_DASHBOARD_APP_TITLE = 'Turnos RAS';

export const normalizeDashboardAppTitle = title =>
  (title || '').trim().toLowerCase();

export const isRasTurnosDashboardApp = title =>
  normalizeDashboardAppTitle(title) ===
  normalizeDashboardAppTitle(RAS_TURNOS_DASHBOARD_APP_TITLE);

export const filterDashboardAppsForConversation = (
  dashboardApps,
  rasIntegrationActive
) =>
  dashboardApps.filter(
    app => !isRasTurnosDashboardApp(app.title) || rasIntegrationActive
  );
